import { render, staticRenderFns } from "./app-notifications.vue?vue&type=template&id=683e7fc2&scoped=true&"
import script from "./app-notifications.vue?vue&type=script&lang=js&"
export * from "./app-notifications.vue?vue&type=script&lang=js&"
import style0 from "./app-notifications.vue?vue&type=style&index=0&id=683e7fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e7fc2",
  null
  
)

export default component.exports